module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "all-notice"
  }, [_c('div', {
    staticClass: "all-notice-header clearfix"
  }, [_c('h4', {
    staticClass: "title fl"
  }, [_vm._v("所有通知")]), _vm._v(" "), _c('span', {
    staticClass: "unread read-count fl"
  }, [_vm._v("未读（" + _vm._s(_vm.unread) + "）")]), _vm._v(" "), _c('span', {
    staticClass: "read read-count fl"
  }, [_vm._v("已读（" + _vm._s(_vm.read) + "）")]), _vm._v(" "), (_vm.list.length > 0) ? _c('a', {
    staticClass: "notice-btn fr",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.markAllRead
    }
  }, [_vm._v("全部标记为已读")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "all-notice-body"
  }, [(_vm.list.length > 0) ? _c('ul', {
    staticClass: "all-notice-list"
  }, _vm._l((_vm.list), function(item, $index) {
    return _c('li', {
      class: {
        'unread': !item.status
      },
      on: {
        "click": function($event) {
          return _vm.markRead($index)
        }
      }
    }, [_c('div', {
      staticClass: "notice-item clearfix"
    }, [_c('p', {
      staticClass: "notice-title fl",
      class: {
        'unread-item': item.status == 0
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(item.title)
      }
    }), _vm._v(" "), (item.addition.length) ? _c('a', {
      staticClass: "show-detail",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.showDetail($index)
        }
      }
    }, [_vm._v(_vm._s(item.detailBtn.text) + "详情"), _c('i', {
      staticClass: "fa",
      class: 'fa-angle-' + (item.detailBtn.icon == 'up' ? 'up' : 'down')
    })]) : _vm._e()]), _vm._v(" "), _c('p', {
      staticClass: "notice-time fr"
    }, [_vm._v(_vm._s(item.elapsed))])]), _vm._v(" "), (item.addition.length) ? _c('div', {
      staticClass: "detail",
      class: {
        collapsed: !item.expanded
      }
    }, _vm._l((item.addition), function(row) {
      return _c('p', {
        domProps: {
          "innerHTML": _vm._s(row)
        }
      })
    }), 0) : _vm._e()])
  }), 0) : _c('div', {
    staticClass: "all-notice-empty"
  }, [_c('img', {
    attrs: {
      "src": require("../../../images/personal_center/work-null.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("暂无消息通知")])])]), _vm._v(" "), (_vm.showLoadMore) ? _c('div', {
    staticClass: "all-notice-footer"
  }, [_c('button', {
    staticClass: "more",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.loadMore()
      }
    }
  }, [_vm._v("加载更多")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-3efc6f34!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/personal_center/notice/all_notice.vue
// module id = RKek
// module chunks = 16